"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Calendar = require("./Calendar");

var _default = _Calendar.Calendar;
exports["default"] = _default;